import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Injector, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JkRichEditorComponent, jkBaseForm } from 'jk-service';

interface HelpData {
  SH001: string;
  SH002: string;
  SH013: string;
  SH019: string;
}

@Component({
  selector: 'app-help-viewer',
  standalone: true,
  imports: [CommonModule, JkRichEditorComponent],
  templateUrl: './help-viewer.component.html',
})
export class HelpViewerComponent extends jkBaseForm implements OnInit {
  override _programId = 'helpviewer';

  data: HelpData | undefined;
  rows: HelpData[] = [];
  rowIndex = 0;
  message = signal('');
  loading = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (!this.isLogin) {
      void this.router.navigate(['/sys/login-form'], {
        queryParams: { returnUrl: this.router.url },
      });
      return;
    }

    this.activatedRoute.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.loadHelp(params.get('SH001')); // , params.get('SH013')
      });
  }

  private loadHelp(sh001: string | null): void {
    this.data = undefined;
    this.rows = [];
    this.rowIndex = 0;
    this.message.set('');
    //if(!sh013) sh013 = '';
    if (!sh001 ) { // || !sh013
      this.loading.set(false);
      this.message.set('缺少必要參數 SH001 。');
      return;
    }

    const programId = this.escapeSqlString(sh001);
    //const creatorId = this.escapeSqlString(sh013);
    const sql = `SELECT * FROM ##SYSSH AS SYSSH WHERE SH001='${programId}'`; // AND SH013='${creatorId}'`;

    this.loading.set(true);
    this.orm.simpleSql(this.host, sql).subscribe({
      next: (response: unknown) => {
        this.loading.set(false);
        if (this.isQueryFailure(response)) {
          this.message.set('讀取說明資料失敗。');
          return;
        }

        this.rows = this.getRows(response);

        if (this.rows.length === 0) {
          this.message.set('查無說明資料。');
          return;
        }

        this.data = this.rows[this.rowIndex];
      },
      error: () => {
        this.loading.set(false);
        this.message.set('讀取說明資料失敗。');
      },
    });
  }

  previousRow(): void {
    if (this.rowIndex === 0) {
      return;
    }

    this.rowIndex--;
    this.data = this.rows[this.rowIndex];
  }

  nextRow(): void {
    if (this.rowIndex >= this.rows.length - 1) {
      return;
    }

    this.rowIndex++;
    this.data = this.rows[this.rowIndex];
  }

  private escapeSqlString(value: string): string {
    return value.replace(/'/g, "''");
  }

  private getRows(response: unknown): HelpData[] {
    if (Array.isArray(response)) {
      return response as HelpData[];
    }

    if (response && typeof response === 'object' && 'obj' in response) {
      const rows = (response as { obj?: unknown }).obj;
      return Array.isArray(rows) ? rows as HelpData[] : [];
    }

    return [];
  }

  private isQueryFailure(response: unknown): boolean {
    return Boolean(
      response
      && typeof response === 'object'
      && 'result' in response
      && (response as { result?: unknown }).result === false,
    );
  }
}
